import React from "react";

import { useAlgoliaQueryHook } from "@utils/hooks/algolia/useAlgoliaQuery.hook";
import { useSharedWishListId } from "@utils/hooks/useSharedWishlistId.hook";

import { setLanguageCookie } from "@services/cookie.service";

import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { getLabel } from "@components/General/LanguageSelector/partials/label.component";

import "./toggle.scss";

type Props = {
    variant?: string;
    languages: Language[];
    current: string;
};

const LanguageToggleSelector = ({
    current,
    languages = [],
    variant,
}: Props) => {
    const algoliaQuery = useAlgoliaQueryHook();
    const sharedWishListId = useSharedWishListId();

    const currentLanguageObject = languages.find(
        language => language.languageCode === current,
    );

    const otherLanguageObject = languages.find(
        language =>
            language.languageCode !== currentLanguageObject?.languageCode,
    );

    return (
        <>
            {otherLanguageObject && (
                <div
                    className={
                        "h-100 d-flex flex-column justify-content-center"
                    }
                >
                    <a
                        className="language-selector__toggle"
                        href={`${otherLanguageObject.path}${algoliaQuery}${sharedWishListId}`}
                        onClick={() =>
                            setLanguageCookie(otherLanguageObject.languageCode)
                        }
                    >
                        {getLabel(otherLanguageObject, variant)}
                    </a>
                </div>
            )}
        </>
    );
};

export default LanguageToggleSelector;
